import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import heroMeaningfulImg from './images/hero-meaningful.png';

const useStyles = makeStyles((theme) => ({
  heroSection: {
    padding: '20px 60px 0 60px',
    backgroundColor: '#0a0a0a',
    marginBottom: '60px',
    maxHeight: 450,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      padding: '20px 30px 0 30px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px 20px 30px',
      maxHeight: 'none',
      marginBottom: '40px',
    },
  },
  heroInner: {
    maxWidth: 1314,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: 0,
      alignItems: 'center',
    },
  },
  heroTextContainer: {
    flex: 1,
    maxWidth: '780px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 'auto',
    marginBottom: 'auto',
    paddingBottom: '40px',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      alignItems: 'center',
      textAlign: 'center',
      maxWidth: '100%',
    },
  },
  heroTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontWeight: 400,
    fontSize: '64px',
    lineHeight: '100%',
    letterSpacing: '0%',
    marginBottom: '20px',
    color: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      fontSize: '44px',
      maxWidth: '360px',
      margin: '0 auto 16px auto',
      textAlign: 'center',
    },
  },
  heroSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 200,
    fontSize: '18px',
    lineHeight: '27px',
    letterSpacing: '0%',
    color: '#ffffff',
    marginBottom: '24px',
    maxWidth: '580px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '24px',
      maxWidth: '340px',
      margin: '0 auto 20px auto',
      textAlign: 'center',
    },
  },
  breadcrumbs: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0%',
    gap: '6px',
    display: 'flex',
    alignItems: 'center',
    color: '#ffffff',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      fontSize: '16px',
      lineHeight: '24px',
      gap: '6px',
      margin: '0 auto',
    },
  },
  breadcrumbLink: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0%',
    color: '#ffffff',
    textDecoration: 'none',
    transition: 'color 0.2s ease',
    '&:hover': {
      color: '#fe5a97',
    },
  },
  breadcrumbActive: {
    fontFamily: '"Roboto", sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '110%',
    letterSpacing: '0%',
    verticalAlign: 'middle',
    color: '#fe5a97',
  },
  heroImageContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  heroImage: {
    width: 'auto',
    maxHeight: 450,
    objectFit: 'contain',
    display: 'block',
  },
}));

export const VirtualCompanionshipHeroSection = () => {
  const classes = useStyles();
  return (
    <Box className={classes.heroSection}>
      <Box className={classes.heroInner}>
        <Box className={classes.heroTextContainer}>
          <Typography className={classes.heroTitle}>
            Meaningful Connections.<br />
            Premium Experiences.
          </Typography>
          <Typography className={classes.heroSubtitle}>
            Connect with verified creators through private conversations, personalized interactions, and exclusive experiences in a secure and discreet environment.
          </Typography>
          <Typography className={classes.breadcrumbs}>
            <Link to="/" className={classes.breadcrumbLink}>Home</Link>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 17L14 12L9 7" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className={classes.breadcrumbActive}>Virtual Companionship</span>
          </Typography>
        </Box>
        <Box className={classes.heroImageContainer}>
          <img
            src={heroMeaningfulImg}
            alt="Meaningful Connections - Premium Experiences"
            className={classes.heroImage}
          />
        </Box>
      </Box>
    </Box>
  );
};

